import { cn } from '@/utils/ui'
import { type VariantProps, cva } from 'class-variance-authority'
import * as React from 'react'

const titleVariants = cva('font-bold', {
  defaultVariants: {
    hierarchy: 'h2',
  },
  variants: {
    hierarchy: {
      h1: 'text-headline-XL-semibold',
      h2: 'text-headline-L-semibold',
      h3: 'text-headline-M-semibold',
      h4: 'text-headline-S-semibold',
      h5: 'text-headline-XS-semibold',
      h6: 'text-headline-XS-regular',
    },
  },
})

export type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'

export interface TitleProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof titleVariants> {
  title?: string
  titleHierarchy?: HeadingTag
  fixedStyle?: HeadingTag
}

const Title: React.FC<TitleProps> = ({
  className,
  hierarchy = 'h2',
  title,
  titleHierarchy,
  fixedStyle,
  children,
  ...props
}) => {
  const TitleTag = (titleHierarchy || hierarchy) as HeadingTag
  const style = fixedStyle || titleHierarchy || hierarchy

  const content = title || children

  return (
    <TitleTag
      className={cn(titleVariants({ hierarchy: style }), className)}
      {...props}
    >
      {content}
    </TitleTag>
  )
}

export { Title, titleVariants }
